import { render } from "./NewsCarousal.vue?vue&type=template&id=5d558815&scoped=true"
import script from "./NewsCarousal.vue?vue&type=script&lang=js"
export * from "./NewsCarousal.vue?vue&type=script&lang=js"

import "./NewsCarousal.vue?vue&type=style&index=0&id=5d558815&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d558815"]])

export default __exports__